import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styles from './notificationCard.module.scss';
import { dateTime } from '../../time/datetime';
import { LinkType } from '../../state/reduxRepositories/notifications/notification.interfaces';
import { Banner } from '../banner/banner';
import { Avatar } from '../avatar/avatar';

interface NotificationCardProps {
  initials: string;
  mainText: string;
  notificationTime: Date;
  linkType: LinkType;
  linkId: string;
  linkText: string;
  read: boolean;
  onClick?: () => void;
  testId?: string;
}

export function NotificationCard({
  initials,
  mainText,
  notificationTime,
  linkType,
  linkId,
  linkText,
  read,
  onClick,
  testId,
}: NotificationCardProps) {
  const { t } = useTranslation();
  return (
    <Box
      data-testid={testId}
      onClick={() => {
        if (onClick) onClick();
      }}
      sx={{
        '&:hover': {
          cursor: 'pointer',
        },
        pr: 2,
        maxWidth: 550,
      }}
    >
      <Banner
        severity="info"
        elevation={2}
        title={mainText}
        subHeader={dateTime.format(
          notificationTime,
          t('common.datetime.FORMAT_ABBREVIATED_DATE_TIME'),
        )}
        icon={
          <Avatar
            title={initials}
            className={
              read ? styles.hideUnreadIndicator : styles.unreadIndicator
            }
          />
        }
      />
    </Box>
  );
}
